/**
 * Tiny CSV builder + browser download. Extracted from AdminUsersScreen so every
 * admin surface exports the same dialect (quote-escaping included) instead of
 * growing private copies.
 */

export function escapeCsvValue(value) {
  const text = value === null || value === undefined ? '' : `${value}`;
  if (text.includes('"') || text.includes(',') || text.includes('\n')) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function downloadCsv(filename, rows) {
  const csv = rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
